// @flow

import type { DispatchType } from "../../global/types/redux";
import Properties from "../../../Properties";
import { getInit, postInit, putInit } from "../../global/types/constants";
import { apiFailCallbackHandle } from "../containers/ErrosDisplay";

const root = Properties.api_root;

export function logErrorMessage(error: string, info: string, doneBack: Function): DispatchType {
  let formData = new FormData();
  formData.append("error", error);
  formData.append("info", info);

  return (dispatch: DispatchType) => {
    fetch(root + "/api/v2/tracks/logs", postInit(formData))
      .then((res: Response): JSON => {
        if (res.status === 200) {
          return res.json();
        }
        else {
          return Promise.reject();
        }
      })
      .then(function (json: JSON): * {
        doneBack && doneBack();
      });
  };
}

export function userLogin(
  username: string,
  password: string,
  doneBack?: Function,
  failBack?: Function
): DispatchType {
  let formData = new FormData();
  formData.append("username", username);
  formData.append("password", password);

  return (dispatch: DispatchType) => {
    fetch(root + "/api/v2/user/login", postInit(formData))
      .then((res: Response): Promise<any> => {
        if (res.ok) {
          return res.json();
        }
        else if (res.status === 400) {
          return res.json();
        }
        else {
          failBack && failBack(apiFailCallbackHandle(res.status));
          return Promise.reject();
        }
      })
      .then(function (json: any): * {
        if (json && json.errors) {
          failBack && failBack(json.errors);
        }
        else if (json && json.challenge) {
          if (json.challenge === "NEW_PASSWORD_REQUIRED") {
            doneBack && doneBack(json.user_names); //{'first_name': '', 'last_name': '' }
          }
          else {
            failBack && failBack(apiFailCallbackHandle("api error"));
          }
        }
        else {
          doneBack && doneBack();
        }
      })
      .catch((err: any) => {
        failBack && failBack(apiFailCallbackHandle(err && err.message ? err.message : "Unknown error"));
      });
  };
}

export function userSignup(
  email: string, password: string, firstName: string, lastName: string,
  companyName: string, doneBack?: Function, failBack?: Function
): DispatchType {
  let formData = new FormData();
  formData.append("email", email);
  formData.append("password", password);
  formData.append("first_name", firstName);
  formData.append("last_name", lastName);
  formData.append("company_name", companyName);

  return (dispatch: DispatchType) => {
    fetch(root + "/api/v2/user/signup", postInit(formData))
      .then((res: Response): JSON => {
        if (res.ok) {
          return res.json();
        }
        else if (res.status === 400) {
          return res.json();
        }
        else {
          failBack && failBack(apiFailCallbackHandle(res.status));
          return Promise.reject();
        }
      })
      .then(function (json: JSON): * {
        if (json.errors) {
          failBack && failBack(json.errors);
        }
        else {
          doneBack && doneBack();
        }
      })
      .catch((err: *): * => {
        failBack && failBack(apiFailCallbackHandle(err.message));
      });
  };
}

export function userChangePassword(oldPassword: string, newPassword: string, doneBack?: Function, failBack?: Function): DispatchType {
  let formData = new FormData();
  formData.append("old_password", oldPassword);
  formData.append("new_password", newPassword);

  return (dispatch: DispatchType) => {
    fetch(root + "/api/v2/user/password", putInit(formData))
      .then((res: Response): JSON => {
        if (res.ok) {
          return res.json();
        }
        else if (res.status === 400) {
          return res.json();
        }
        else {
          failBack && failBack(apiFailCallbackHandle(res.status));
          return Promise.reject();
        }
      })
      .then(function (json: JSON): * {
        if (json.errors) {
          failBack && failBack(json.errors);
        }
        else {
          doneBack && doneBack();
        }
      });
  };
}

export function userConfirm(firstName: string, lastName: string, userName: string, password: string, doneBack?: Function, failBack?: Function): DispatchType {
  let formData = new FormData();
  formData.append("first_name", firstName);
  formData.append("last_name", lastName);
  formData.append("preferred_username", userName);
  formData.append("password", password);

  return (dispatch: DispatchType) => {
    fetch(root + "/api/v2/user/confirm", postInit(formData))
      .then((res: Response): JSON => {
        if (res.ok) {
          return res.json();
        }
        else if (res.status === 400) {
          return res.json();
        }
        else {
          failBack && failBack(apiFailCallbackHandle(res.status));
          return Promise.reject();
        }
      })
      .then(function (json: JSON): * {
        if (json.errors) {
          failBack && failBack(json.errors);
        }
        else {
          doneBack && doneBack();
        }
      });
  };
}

export function userForgotPassword(username: string, doneBack?: Function, failBack?: Function): DispatchType {
  return (dispatch: DispatchType) => {
    fetch(root + "/api/v2/users/" + username + "/forgot", postInit())
      .then((res: Response): JSON => {
        if (res.ok) {
          return res.json();
        }
        else if (res.status === 400) {
          return res.json();
        }
        else {
          failBack && failBack(apiFailCallbackHandle(res.status));
          return Promise.reject();
        }
      })
      .then(function (json: JSON): * {
        if (json.errors) {
          failBack && failBack(json.errors);
        }
        else {
          doneBack && doneBack();
        }
      });
  };
}

export function userSetNewPassword(username: string, password: string, confirmCode: string, doneBack?: Function, failBack?: Function): DispatchType {
  let formData = new FormData();
  formData.append("password", password);
  formData.append("confirmation_code", confirmCode);

  return (dispatch: DispatchType) => {
    fetch(root + "/api/v2/users/" + username + "/forgot", putInit(formData))
      .then((res: Response): JSON => {
        if (res.ok) {
          return res.json();
        }
        else if (res.status === 400) {
          return res.json();
        }
        else {
          failBack && failBack(apiFailCallbackHandle(res.status));
          return Promise.reject();
        }
      })
      .then(function (json: JSON): * {
        if (json.errors) {
          failBack && failBack(json.errors);
        }
        else {
          doneBack && doneBack();
        }
      });
  };
}
